// import * as angular from 'angular';

export class LocalStoreService {
  // constructor() {}

  get(key) {
    return localStorage.getItem(key);
  }

  set(key, val) {
    return localStorage.setItem(key, val);
  }

  unset(key) {
    return localStorage.removeItem(key);
  }

  // get stored token
  token(key) {
    const data = JSON.parse(this.get(key));

    if (data && data.token) {
      return data.token;
    }

    return null;
  }
}
